export default {"src":"/_next/static/media/puzzle.1f8d111b.svg","height":50,"width":45,"blurWidth":0,"blurHeight":0};